module.exports = __webpack_public_path__ + "routes/urzad/images/waiting-wheel-300x300.gif?1fce61e9";


//////////////////
// WEBPACK FOOTER
// ./routes/urzad/images/waiting-wheel-300x300.gif
// module id = 1843
// module chunks = 0